import React from 'react';
import Bone from '@lightspeed/cirrus-bone';
import Card, { CardSection } from '@lightspeed/cirrus-card';

const Skeleton = () => (
  <Card>
    <CardSection>
      <div className="cr-width-full cr-pl-3 cr-pr-4 cr-pt-4 cr-pb-4">
        <Bone height="0.8rem" />
      </div>
    </CardSection>
  </Card>
);

export default Skeleton;
